import { Box, Typography, TextField, FormControl, FormLabel, Select, MenuItem, FormHelperText } from "@mui/material";
import { Control, FieldError, UseFormRegisterReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { paypalAccountTypeEnum } from "../schema";
import FormTextField from "./FormTextField";
import { currencyList } from "./currency";

type WalletDetailsOtherStepFieldsProps = {
  errors: {
    accountType?: FieldError;
    email?: FieldError;
    reEnterEmail?: FieldError;
    phoneNumber?: FieldError;
    currency?: FieldError;
  };
  register: {
    accountType: UseFormRegisterReturn;
    email: UseFormRegisterReturn;
    reEnterEmail: UseFormRegisterReturn;
    phoneNumber: UseFormRegisterReturn;
    currency: UseFormRegisterReturn;
  };
};

const WalletDetailsOtherStepFields = ({ errors, register }: WalletDetailsOtherStepFieldsProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", rowGap: "24px", padding: "0 24px" }}>
      <Typography
        component="h5"
        sx={{
          color: "var(--Gray-600, #475467)",
          fontFamily: "Montserrat",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "28px",
        }}
      >
        {t("pages.payment.overview.v2.receivingDetailsPopUp.bankAccountDetailsDescription")}
      </Typography>
      <FormTextField
        register={register.email}
        error={errors.email}
        label={t("pages.payment.overview.v2.receivingDetailsPopUp.emailLabel")}
      />
      <FormTextField
        register={register.reEnterEmail}
        error={errors.reEnterEmail}
        label={t("pages.payment.overview.v2.receivingDetailsPopUp.reEnterEmailLabel")}
      />
      <FormControl
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: "6px",
        }}
        error={!!errors.currency}
      >
        <FormLabel
          sx={{
            color: "#344054",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          {t("pages.payment.overview.v2.receivingDetailsPopUp.accountTypeLabel")}
        </FormLabel>

        <Select {...register.accountType} error={!!errors.accountType}>
          {paypalAccountTypeEnum.options.map((value: string) => (
            <MenuItem value={value}>{t(`pages.payment.overview.v2.receivingDetailsPopUp.${value}`)}</MenuItem>
          ))}
        </Select>

        {!!errors.accountType && <FormHelperText>{errors.accountType.message}</FormHelperText>}
      </FormControl>
      <FormTextField
        register={register.phoneNumber}
        error={errors.phoneNumber}
        label={t("pages.payment.overview.v2.receivingDetailsPopUp.phoneNumberLabel")}
      />
      <FormControl
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: "6px",
        }}
        error={!!errors.currency}
      >
        <FormLabel
          sx={{
            color: "#344054",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          {t("pages.payment.overview.v2.receivingDetailsPopUp.currencyLabel")}
        </FormLabel>

        <Select {...register.currency} error={!!errors.currency}>
          {/* {currencyList?.map((value: string) => <MenuItem value={value}>{value}</MenuItem>)} */}
          {currencyList?.map((value: string) => value !== "EGP" && <MenuItem value={value}>{value}</MenuItem>)}
        </Select>

        {!!errors.currency && <FormHelperText>{errors.currency.message}</FormHelperText>}
      </FormControl>
    </Box>
  );
};

export default WalletDetailsOtherStepFields;
